// FilePond draws its UI and applies most store actions only inside its requestAnimationFrame loop.
// Some virtual desktop sessions stop sending animation frames to a visible page until the window is
// resized, so the upload field freezes. When frames stop, drive FilePond's shared painter from a timer.
const STALL_MS = 100;
const FALLBACK_INTERVAL_MS = 1000 / 30;

let lastFrameAt = performance.now();

const trackFrames = (now) => {
    lastFrameAt = now;
    requestAnimationFrame(trackFrames);
};

const paintFilePond = () => {
    const painter = window.__framePainter;
    const now = performance.now();

    if (!painter || document.hidden || now - lastFrameAt < STALL_MS) {
        return;
    }

    painter.readers.forEach((read) => read());
    painter.writers.forEach((write) => write(now));
};

const filePondFrameFallback = () => {
    requestAnimationFrame(trackFrames);
    setInterval(paintFilePond, FALLBACK_INTERVAL_MS);
};

export default filePondFrameFallback;
